module.exports = __webpack_public_path__ + "img/bh.bd925c29.svg";